import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {
  TextV2,
  SvgSingleNeutralBold,
  DetailsHeader,
} from '@insights-ltd/design-library/components';
import { PractitionerData } from 'api';
import LinkEmail from 'components/LinkEmail/LinkEmail';
import { useGetApplicationPreferredDialects } from 'domain/dialect';
import { useBetaEnabled } from 'features';
import { roleDescription } from 'utils/mappers/entityMappers';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const UserInfoSection = ({
  emailAddress,
  practitioner,
}: {
  emailAddress: string;
  practitioner?: PractitionerData;
}) => {
  const { t } = useTranslation();
  const role = t(roleDescription(practitioner?.role ?? 'STANDARD'));
  const isBetaEnabled = useBetaEnabled('supported-languages');

  const preferredDialect =
    useGetApplicationPreferredDialects(isBetaEnabled)[
      practitioner?.preferredDialect ?? 'en-GB'
    ];

  return (
    <>
      <DetailsHeader
        Icon={SvgSingleNeutralBold}
        text={t('ui.event-management.my-account.information')}
        id="user-info"
        sx={{
          marginBottom: spacingSizeMap.S,
        }}
      />
      <Grid
        container
        sx={{
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginTop: '20px',
        }}
      >
        <TextV2 component="p" variant="bodyBold" color="textSecondary">
          {t('ui.event-management.my-account.email-address')}
        </TextV2>
        <LinkEmail sx={{ maxWidth: 'unset' }} email={emailAddress} />
      </Grid>
      <Grid
        container
        sx={{
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginTop: '12px',
        }}
      >
        <TextV2 component="p" variant="bodyBold" color="textSecondary">
          {t('ui.event-management.my-account.role')}
        </TextV2>
        <TextV2 component="p" variant="bodyBold">
          {role}
        </TextV2>
      </Grid>
      <Grid
        container
        sx={{
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginTop: '12px',
        }}
      >
        <TextV2 component="p" variant="bodyBold" color="textSecondary">
          {t('ui.event-management.my-account.preferred-language')}
        </TextV2>
        <TextV2 component="p" variant="bodyBold">
          {t(preferredDialect)}
        </TextV2>
      </Grid>
      <Box
        sx={{
          mb: '40px',
        }}
      />
    </>
  );
};

export default UserInfoSection;
